// extracted by mini-css-extract-plugin
export default {"button":"AiPhotoGenerationEntryButton__button--23Id2","text":"AiPhotoGenerationEntryButton__text--1C9DE"};